import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "../../../context/app/context";
import { ICity } from "../../../models/city/response";
import AreaContext from "../../../context/discount-areas/context";
import EndPoints from "../../../services/end-points";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import { getAreaStatus } from "../../../models/discount-areas/enum";

interface IProps {}

const AreaFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(AreaContext);
  const { direction } = useContext(AppContext);
  const [cities, setCities] = useState<ICity[]>([]);
  const [citiesLoading, setCitiesLoading] = useState(true);

  const statuses = [1, 2];

  useEffect(() => {
    const getcities = async () => {
      try {
        const { data } = await EndPoints.city.getAllCities({
          light: true,
          perPage: -1,
        });
        setCities(data.data);
        setCitiesLoading(false);
      } catch (error) {
      } finally {
        setCitiesLoading(false);
      }
    };
    getcities();
  }, [direction]);

  return (
    <Form
      formId="discount-area-filter"
      onSubmit={(data) => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: data?.keyword,
          filters: [
            data?.status
              ? {
                  name: "status",
                  value: data.status,
                  operation: "eq",
                }
              : undefined,
            data?.cityId
              ? {
                  name: "cityId",
                  value: data.cityId,
                  operation: "eq",
                }
              : undefined,
          ].filter((f) => f),
        };
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="status"
            label={`${t("status")}`}
            width="large"
            input={{
              type: "select",
              options: statuses.map((status, index) => {
                return {
                  label: t(getAreaStatus(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="cityId"
            label={`${t("city")}`}
            width="large"
            input={{
              type: "select",
              allowSearch: true,
              loading: citiesLoading,
              options: cities.map((jop, index) => {
                return {
                  label: jop.name,
                  value: jop.id,
                };
              }),
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default AreaFilter;
